import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  GetFeaturedShiftsCampaign,
  FeaturedShiftsCampaignsFetching,
  ClearFeaturedShiftsCampaignReducer,
} from 'data/upshifter/FeaturedShiftsCampaign/actions'
import { IFeaturedShiftsCampaignReducer } from 'models/FeaturedShiftsCampaign'

const initialState: IFeaturedShiftsCampaignReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: null,
}

export const featuredShiftsCampaignReducer = (
  state = initialState,
  action: Action,
): IFeaturedShiftsCampaignReducer => {
  if (isType(action, GetFeaturedShiftsCampaign)) {
    const { payload } = action
    return {
      ...state,
      data: payload,
    }
  }
  if (isType(action, FeaturedShiftsCampaignsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, ClearFeaturedShiftsCampaignReducer)) {
    return initialState
  }
  return state
}
